import {NgModule} from "@angular/core";
import {IonicPageModule} from "ionic-angular";
import {TranslateModule} from "@ngx-translate/core";
import {DynamicSelectComponent} from './dynamic-select';
import {DynamicSelectOptions} from './dynamic-select.options';
import {FilterPipeModule} from '../../pipes/filter/filter.pipe.module';
import {NoResultsComponentModule} from '../no-results/no-results.module';
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    DynamicSelectComponent,
    DynamicSelectOptions,
  ],
  imports: [
    IonicPageModule.forChild(DynamicSelectComponent),
    TranslateModule.forChild(),
    FilterPipeModule,
    NoResultsComponentModule,
    DirectivesModule
  ],
  exports: [
    DynamicSelectComponent,
    DynamicSelectOptions,
  ],
  entryComponents: [
    DynamicSelectOptions
  ]
})
export class DynamicSelectComponentModule {
}



// WEBPACK FOOTER //
// ./src/components/dynamic-select/dynamic-select.module.ts